import { CognitoAuth } from 'amazon-cognito-auth-js';
import { Storage } from '@intelipost-js/secure-providers';

export default {
  getAuth() {
    const authCognito = new CognitoAuth(Storage.get('cognito_data', 'local'));
    return authCognito;
  },

  getExpiredDays(state) {
    return state.expired;
  },
};



// WEBPACK FOOTER //
// ./src/stores/auth/getters.js